<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Cotización de Acción</template>
                    <template slot="en">Stock Quote</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
        <div class="container">
            <list-content>
                <list-content-item>
                    <div style="border-bottom: 1px solid #ccc">
                        <box-container class="box-container-text box-container-collapse box-container-collapse-716" size="3">
                            <box>
                                <div class="title-content title-content-big">ICP.B</div>
                            </box>
                            <box class="d-flex align-items-center">
                                <div class="text text-secondary" style="white-space: nowrap;">Inversiones Crece Pymes C.A.</div>
                            </box>
                            <box class="d-flex align-items-center text-right">
                                <div class="text text-secondary">BVC</div>
                            </box>
                        </box-container>
                    </div>
                    <div style="margin-top: 20px; margin-bottom:30px !important">
                        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" :duration="200">
                            <div v-if="!bvc.loading && !bvc.error">
                                <box-container class="box-container-text" size="3" style="grid-template-columns: 1fr 2fr;">
                                    <box>
                                        <div class="list-rates">
                                            <div class="rate">
                                                <div class="text text-primary">
                                                    <span v-if="bvc.data.price">{{bvc.data.price | numberFormat}}</span>
                                                    <span v-else>-</span>
                                                    <span> BsS</span>
                                                </div>
                                                <div class="text text-secondary" style="font-size:14px">
                                                    <text-lang :lang="lang">
                                                        <template slot="es">Precio</template>
                                                        <template slot="en">Quote</template>
                                                    </text-lang>
                                                </div>
                                            </div>
                                            <div class="rate rate-doble">
                                                <div>
                                                    <div class="text text-primary" style="font-size:28px !important">
                                                        <span v-if="bvc.data.change && bvc.data.change.value">
                                                            <span :style="{color: colorChange(bvc.data.change.value)}">{{bvc.data.change.value | numberFormat}}</span>
                                                        </span>
                                                        <span v-else>-</span>
                                                    </div>
                                                    <div class="text text-secondary" style="font-size:14px">
                                                        <text-lang :lang="lang">
                                                            <template slot="es">Cambio</template>
                                                            <template slot="en">Change</template>
                                                        </text-lang>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="text text-primary" style="font-size:28px !important" :style="{color: colorChange(bvc.data.change.percentage)}">
                                                        <span v-if="bvc.data.change && bvc.data.change.percentage">
                                                            <span>{{bvc.data.change.percentage | percentage | numberFormat}}</span>
                                                        </span>
                                                        <span v-else>-</span>
                                                        <span> %</span>
                                                    </div>
                                                    <div class="text text-secondary" style="font-size:14px">
                                                        <text-lang :lang="lang">
                                                            <template slot="es">Cambio %</template>
                                                            <template slot="en">Change %</template>
                                                        </text-lang>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </box>
                                    <box>
                                        <list-content class="list-content-download-secondary">
                                            <list-content-item>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text text-tertiary">Market Cap (en millones)</div>
                                                    <div class="text text-tertiary">
                                                        <span v-if="bvc.data.market_cap">{{bvc.data.market_cap | numberFormat}}</span>
                                                        <span v-else>-</span>
                                                        <span> BsS</span>
                                                    </div>
                                                </div>
                                            </list-content-item>
                                            <list-content-item>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text text-tertiary">Volume</div>
                                                    <div class="text text-tertiary">
                                                        <span v-if="bvc.data.volume">{{bvc.data.volume.title | numberFormat}}</span>
                                                        <span v-else>-</span>
                                                    </div>
                                                </div>
                                            </list-content-item>
                                            <list-content-item>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text text-tertiary">Today's open</div>
                                                    <div class="text text-tertiary">
                                                        <span v-if="bvc.data.open">{{bvc.data.open | numberFormat}}</span>
                                                        <span v-else>-</span>
                                                        <span> BsS</span>
                                                    </div>
                                                </div>
                                            </list-content-item>
                                            <list-content-item>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text text-tertiary">Previous Close</div>
                                                    <div class="text text-tertiary">
                                                        <span v-if="bvc.data.previous_close">{{bvc.data.previous_close | numberFormat}}</span>
                                                        <span v-else>-</span>
                                                        <span> BsS</span>
                                                    </div>
                                                </div>
                                            </list-content-item>
                                        </list-content>
                                    </box>
                                </box-container>
                            </div>
                            <try-again v-else-if="!bvc.loading && bvc.error" :lang="lang" @stockSynchronize="$emit('stockSynchronize')" />
                            <loader :lang="lang" v-else />
                        </transition>
                    </div>
                </list-content-item>
            </list-content>
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import ListContent from '@/components/ListContent.vue'
import ListContentItem from '@/components/ListContentItem.vue'
import BoxContainer from '@/components/BoxContainer.vue'
import Box from '@/components/Box.vue'
import TextLang from '@/components/TextLang.vue'
import Loader from '@/components/Loader.vue'
import TryAgain from '@/components/TryAgain.vue'
import colorChange from '@/mixins/colorChange'

export default {
    name: 'StockQuote',
    mixins: [colorChange],
    props: ['bvc', 'lang'],
    components: {
        Parallax,
        ListContent,
        ListContentItem,
        BoxContainer,
        Box,
        TextLang,
        Loader,
        TryAgain
    }
}
</script>